import client, { PaginatedResponse } from '@/utils/client'
import urls from '@/utils/urls'

var defaultState = {}

export const postVisibilities = {
  private: 'Private (visible only to selected users)',
  subscribers: 'Visible to subscribers only',
  public: 'Public (visible to all fans and unregistered users)'
}

export const mutations = {
}

export const getters = {
}

export const actions = {
  getCombinedFeed (ctx) {
    return client.get(urls.feed.combined()).then(response => new PaginatedResponse(response.data))
  },
  getUserFeed (ctx, {id}) {
    return client.get(urls.feed.by(id)).then(response => new PaginatedResponse(response.data))
  },
  postUpdate (ctx, update) {
    return client.post(urls.feed.post(), update).then(response => response.data)
  },
  deleteUpdate (ctx, {id}) {
    return client.delete(urls.feed.delete(id)).then(response => response.data)
  },
  getUpdateComments (ctx, {id}) {
    return client.get(urls.feed.commentList(id)).then(response => new PaginatedResponse(response.data))
  },
  async reportUpdate ({ dispatch }, { id, reason, url }) {
    return client.post(urls.feed.reportUpdate(id), { reason, url })
  },
  postUpdateComment (ctx, {id, text, asArtist = false}) {
    return client
      .post(urls.feed.commentList(id), {text, as_artist: asArtist})
      .then(response => response.data)
  },
  deleteUpdateComment (ctx, {updateId, commentId}) {
    return client
      .delete(urls.feed.commentDetail(updateId, commentId))
      .then(response => response.data)
  },
  async reportUpdateComment ({ dispatch }, { subjectId, commentId, reason, url }) {
    return client.post(urls.feed.reportUpdateComment(subjectId, commentId), { reason, url })
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/feed.js